import { Grid, Tooltip } from "@material-ui/core";
import { CheckCircle, RemoveCircleOutline } from "@material-ui/icons";
import IconPen from "app/common/Icon/IconPen";
import { APPOINTMENT_TAB, APPOINTMENT_TYPE } from "app/common/LocalConst";
import { getDateTime, isRoleHisReadOnly } from "app/common/LocalFunction";
import AppointmentListPopup from "app/PatientManagement/AppointmentList/Popup/AppointmentListPopup";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const images = [
  {
    src: "https://cdnvttimg.vttechsolution.com/Second/ImageLinhAnh/5164/Phieutvpt/img_7457.jpeg(20250512082547).webp",
    thumb:
      "https://cdnvttimg.vttechsolution.com/Second/ImageLinhAnh/5164/Phieutvpt/img_7457.jpeg(20250512082547)(fea).webp",
    alt: "Ảnh 1",
  },
  {
    src: "https://cdnvttimg.vttechsolution.com/Second/ImageLinhAnh/5164/Phieutvpt/img_7458.jpeg(20250512082547).webp",
    thumb:
      "https://cdnvttimg.vttechsolution.com/Second/ImageLinhAnh/5164/Phieutvpt/img_7458.jpeg(20250512082547)(fea).webp",
    alt: "Ảnh 2",
  },
];
const ListAppointmentBlock = ({
  initialPatient,
  setCurrentTab,
  handleAfterSubmit,
}) => {
  const {
    openFormCreateOrEdit,
    updateAppointmentStatus,
    initialAppointment,
    handleCloseCreateOrEditPopup,
    handleOpenFormCreateOrEdit,
    saveOrUpdateAppoint,
  } = useStore().patientManagementStore.appointmentListStore;
  const { listVatPercent } =
    useStore().patientManagementStore.patientGeneralStore;
  const { t } = useTranslation();
  const isReadonly = isRoleHisReadOnly();
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Lịch hẹn</p>
          <div className="flex align-center flex-end gap-1 cursor">
            <p
              className="button-more"
              onClick={() => setCurrentTab(APPOINTMENT_TAB)}
            >
              Xem thêm
            </p>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ overflowY: "auto", maxHeight: "400px" }}
          className="custom-scrollbar"
        >
          {(initialPatient?.appointmentList || []).map((item, index) => (
            <div
              style={{
                borderBottom: "1px solid gray",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div key={index} style={{ padding: "10px" }}>
                <div className="flex gap-2 items-center">
                  <span
                    style={{
                      fontSize: "var(--fs-base)",
                      fontWeight: 600,
                      color: "#3faef4",
                      borderBottom: "3px solid #3faef4",
                      paddingBottom: "2px",
                    }}
                  >
                    TG hẹn: {getDateTime(item?.startTime)}
                  </span>
                  {item?.checkinTime && (
                    <>
                      <span> - </span>
                      <span
                        style={{
                          fontSize: "var(--fs-base)",
                          fontWeight: 600,
                          color: "#61c185",
                          borderBottom: "3px solid #61c185",
                          paddingBottom: "2px",
                        }}
                      >
                        TG Đến: {getDateTime(item?.checkinTime)}
                      </span>
                    </>
                  )}
                </div>

                <div className="flex gap-2 mt-2">
                  <span
                    style={{
                      fontSize: "var(--fs-base-two)",
                      color: "#6B7280",
                      fontWeight: 400,
                    }}
                  >
                    {APPOINTMENT_TYPE.find(
                      (el) => el.value === item.appointmentType
                    )?.name || "Loại lịch"}
                  </span>
                  <span
                    style={{
                      fontSize: "var(--fs-base-two)",
                      color: "#6B7280",
                      fontWeight: 400,
                    }}
                  >
                    {item.department?.name || "Không có cơ sở"}
                  </span>
                  <span
                    style={{
                      fontSize: "var(--fs-base-two)",
                      color: "#6B7280",
                      fontWeight: 500,
                    }}
                  >
                    {item.appointmentCode || "Mã lịch hẹn"}
                  </span>
                </div>

                <div style={{ marginTop: "8px" }}>
                  <div
                    style={{
                      fontSize: "var(--fs-base-two)",
                      color: "#374151",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "var(--fs-base-two)",
                        color: "black",
                        fontWeight: "bold",
                        marginBottom: "4px",
                      }}
                    >
                      Ghi chú:
                    </span>{" "}
                    {item.note || "Không có ghi chú"}
                  </div>
                </div>

                {(item?.isReminded ||
                  item?.noteReminded ||
                  item?.reminderAgent) && (
                  <div
                    className="flex flex-col mt-2 gap-1"
                    style={{
                      fontSize: "var(--fs-base-two)",
                      color: "#374151",
                      alignItems: "center",
                    }}
                  >
                    <div className="flex items-center gap-1">
                      <span style={{ fontWeight: 600 }}>Đã nhắc lịch hẹn:</span>
                      {item?.isReminded ? (
                        <CheckCircle
                          style={{ color: "#4caf50", fontSize: 18 }}
                        />
                      ) : (
                        <RemoveCircleOutline
                          style={{
                            color: "#9e9e9e",
                            fontSize: 18,
                            opacity: 0.6,
                          }}
                        />
                      )}
                    </div>

                    <div>
                      <span style={{ fontWeight: 600 }}>Note tương tác:</span>{" "}
                      {item.noteReminded || ""}
                    </div>

                    <div>
                      <span style={{ fontWeight: 600 }}>Người nhắc:</span>{" "}
                      {item.reminderAgent?.staffName || ""}
                    </div>
                  </div>
                )}
              </div>
              <div className="flex-center gap-2" style={{ padding: "25px" }}>
                {!isReadonly && (
                  <Tooltip title="Chỉnh sửa">
                    <div
                      className="flex"
                      onClick={() => {
                        handleOpenFormCreateOrEdit(item);
                      }}
                    >
                      <IconPen />
                    </div>
                  </Tooltip>
                )}
              </div>
            </div>
          ))}
        </Grid>

        {openFormCreateOrEdit && (
          <AppointmentListPopup
            open={openFormCreateOrEdit}
            handleClose={handleCloseCreateOrEditPopup}
            initialValues={initialAppointment}
            listVatPercent={listVatPercent}
            handleSubmit={async (values, { setSubmitting }) => {
              await saveOrUpdateAppoint(values, { setSubmitting });
              handleAfterSubmit();
            }}
          />
        )}
      </Grid>
      {/* <Grid item xs={12}>
        <h2>Thư viện ảnh</h2>
        <LightGallary images={images} />
      </Grid> */}
    </div>
  );
};

export default memo(observer(ListAppointmentBlock));
